// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"88":"AlgoliaSearch","154":"ProductDetailsModal","402":"beef","477":"CatalogTakeawayPopup","827":"PartnerOrderPopup"}[chunkId] || chunkId) + ".1361d5c.js";
};